class VideoCarousel {
  constructor(element) {
    this.carousel = element;
    this.track = this.carousel.querySelector('.carousel-track');
    this.items = Array.from(this.carousel.querySelectorAll('.carousel-vid-item'));
    this.prevBtn = this.carousel.querySelector('.carousel-nav.prev');
    this.nextBtn = this.carousel.querySelector('.carousel-nav.next');
    this.dotsContainer = this.carousel.querySelector('.carousel-dots');
    
    this.currentIndex = 0;
    this.totalItems = this.items.length;
    
    this.init();
  }
  
  init() {
    if (this.totalItems === 0) return;
    
    // Create dots
    this.createDots();
    
    // Add event listeners
    this.prevBtn.addEventListener('click', () => this.prev());
    this.nextBtn.addEventListener('click', () => this.next());
    
    // Add scroll listener to pause videos
    window.addEventListener('scroll', () => this.pauseAllVideos());
    
    // Update button states
    this.updateButtons();
    this.updateDots();
    
    // Touch/swipe support
    this.addSwipeSupport();
  }
  
  createDots() {
    this.items.forEach((_, index) => {
      const dot = document.createElement('button');
      dot.classList.add('carousel-dot');
      dot.setAttribute('aria-label', `Go to slide ${index + 1}`);
      dot.addEventListener('click', () => this.goToSlide(index));
      this.dotsContainer.appendChild(dot);
    });
    this.dots = Array.from(this.dotsContainer.querySelectorAll('.carousel-dot'));
  }
  
  goToSlide(index) {
    this.pauseAllVideos();
    this.currentIndex = index;
    const offset = -index * 100;
    this.track.style.transform = `translateX(${offset}%)`;
    this.updateButtons();
    this.updateDots();
  }
  
  prev() {
    if (this.currentIndex > 0) {
      this.goToSlide(this.currentIndex - 1);
    }
  }
  
  next() {
    if (this.currentIndex < this.totalItems - 1) {
      this.goToSlide(this.currentIndex + 1);
    }
  }
  
  updateButtons() {
    // Disable prev button at start
    this.prevBtn.disabled = this.currentIndex === 0;
    
    // Disable next button at end
    this.nextBtn.disabled = this.currentIndex === this.totalItems - 1;
  }
  
  updateDots() {
    this.dots.forEach((dot, index) => {
      dot.classList.toggle('active', index === this.currentIndex);
    });
  }
  
  pauseAllVideos() {
    this.items.forEach(item => {
      const video = item.querySelector('video');
      if (video && !video.paused) {
        video.pause();
      }
    });
  }
  
  addSwipeSupport() {
    let startX = 0;
    let currentX = 0;
    let isDragging = false;
    
    this.track.addEventListener('touchstart', (e) => {
      startX = e.touches[0].clientX;
      isDragging = true;
    });
    
    this.track.addEventListener('touchmove', (e) => {
      if (!isDragging) return;
      currentX = e.touches[0].clientX;
    });
    
    this.track.addEventListener('touchend', () => {
      if (!isDragging) return;
      isDragging = false;
      
      const diff = startX - currentX;
      const threshold = 50;
      
      if (diff > threshold) {
        this.next();
      } else if (diff < -threshold) {
        this.prev();
      }
    });
  }
}

// Initialize all video carousels on page
document.addEventListener('DOMContentLoaded', () => {
  const carousels = document.querySelectorAll('.video-carousel');
  carousels.forEach(carousel => new VideoCarousel(carousel));
});

// Reinitialize on Shopify section reload (for Theme Editor)
if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', () => {
    const carousels = document.querySelectorAll('.video-carousel');
    carousels.forEach(carousel => new VideoCarousel(carousel));
  });
}